export default function getBrowserName(browserAgent: string) {
  let browserName = "unknown";

  if (browserAgent.includes("Edg")) {
    browserName = "edge";
  } else if (browserAgent.includes("Chrome") && !browserAgent.includes("Edg")) {
    browserName = "chrome";
  } else if (browserAgent.includes("Firefox")) {
    browserName = "firefox";
  } else if (browserAgent.includes("Safari") && !browserAgent.includes("Chrome")) {
    browserName = "safari";
  } else if (browserAgent.includes("Opera") || browserAgent.includes("OPR")) {
    browserName = "opera";
  } else if (browserAgent.includes("Trident") || browserAgent.includes("MSIE")) {
    browserName = "internet_explorer";
  }

  return browserName;
}